export enum ErrorType {
    DUPLICATE_ENTRY = "DUPLICATE_ENTRY",
    NULL_CONSTRAINT_VIOLATION = "NULL_CONSTRAINT_VIOLATION",
    MYSQL_ERROR = "MYSQL_ERROR",
    UNEXPECTED_ERROR = "UNEXPECTED_ERROR",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    WENT_WRONG = "WENT_WRONG"
}

export const ErrorMessages = {
    [ErrorType.DUPLICATE_ENTRY]: "Participant already exists.",
    [ErrorType.NULL_CONSTRAINT_VIOLATION]: "Cannot insert null values.",
    [ErrorType.MYSQL_ERROR]: "An error occurred while processing your request.",
    [ErrorType.UNEXPECTED_ERROR]: "An unexpected error occurred.",
    [ErrorType.INTERNAL_SERVER_ERROR]: "Internal server error occurred.",
    [ErrorType.WENT_WRONG] : "Something went wrong. Please try again later!",
    "ExclusiveContent" : {
         "TOKEN_LIMIT_EXCEEDED":"Content exceeds the maximum limit of 5,000 words."
    }
};
export const SuccessMessages = {
    // [ErrorType.DUPLICATE_ENTRY]: "Participant already exists.",
    "ExclusiveContent" : {
        "SAVED_DRAFT_MASSAGE":"Successfully saved in draft.",
        "FINALIZED_MESSAGE":"Successfully finalized."
    }
};

export const WarnMessages = {
    "ExclusiveContent" : {
        "REQUIRED_FIELD":"Please provide a title and description.",
        "REACHED_MAX_WORD": "You have reached maximum limit of 5,000 words"
    }
};

export interface ErrorResponse {
    success: boolean;
    message?: string;
    errorType?: ErrorType;
}
